import { render, staticRenderFns } from "./SendEmailResult.vue?vue&type=template&id=83d0109e&scoped=true&"
import script from "./SendEmailResult.vue?vue&type=script&lang=js&"
export * from "./SendEmailResult.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailResult.vue?vue&type=style&index=0&id=83d0109e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d0109e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83d0109e')) {
      api.createRecord('83d0109e', component.options)
    } else {
      api.reload('83d0109e', component.options)
    }
    module.hot.accept("./SendEmailResult.vue?vue&type=template&id=83d0109e&scoped=true&", function () {
      api.rerender('83d0109e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SendEmailResult.vue"
export default component.exports